var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"card-header"},[_c('div',[_c('b-card-title',[_vm._v(_vm._s(_vm.titulo))])],1)]),_c('b-card-body',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }